import { fileStorageLinkedServiceValidators } from 'shell-models-lib';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

fileStorageLinkedServiceValidators.validateAKVLinkedserviceReference = validateAKVLinkedserviceReference;
export { AzureFileStorageLinkedService } from 'shell-models-lib';
